<template>
  <section id="content">
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width:45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:center;">Status</th>
                    <th style="text-align:left;">Used By</th>
                    <th style="text-align:left;">ClientHub ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td nowrap style="text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                      <a href="#" v-on:click="onAssign(row)" style="padding-right:5px">
                        <span class="icon ion-check-square-o" data-toggle="tooltip" data-placement="right" title="Assign Location"></span>
                      </a>
                      <a href="#" v-on:click="onDisplayQRCode(row)" style="padding-right:5px">
                        <span class="icon ion-qrcode" data-toggle="tooltip" data-placement="right" title="Display QRCode"></span>
                      </a>                      
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>                    
                    <td style="text-align:left;">{{ row.projectName }}</td>
                    <td style="text-align:center;">{{ row.status }}</td>
                    <td style="text-align:left;">{{ row.usedBy }}</td>
                    <td style="text-align:left;">{{ row.clientHubId }}</td>
                    <td hidden>{{ row.projectId }}</td>                   
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div :id="VIEW_FORM" v-if="viewType == VIEW_FORM">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <div class="col-md-5">                    
                      <div>
                        <label for="inputName">Name</label>
                        <h1 style="margin-top:0px;">
                          <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Location Name" v-model="formData.name">
                        </h1>                        
                      </div>                                          
                    </div>                    
                  </div>
                  <div class="form-group">
                    <div class="col-md-5">
                      <label for="inputProject">Project</label>
                      <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW">
                        <option v-for="(row, i) in listProjectForm" v-bind:key="i" v-bind:value="row.id">
                          {{ row.name }}
                        </option>
                      </select>                                        
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-md-5">                    
                      <div>
                        <label for="inputStatus">Status</label>
                        <input type="text" readonly class="form-control" id="inputStatus" placeholder="" v-model="formData.status">                       
                      </div>                                          
                    </div>                    
                  </div>
                  <div class="form-group">
                    <div class="col-md-5">                    
                      <div>
                        <label for="inputUsedBy">Used By</label>
                        <input type="text" readonly class="form-control" id="inputUsedBy" placeholder="" v-model="formData.usedBy">                       
                      </div>                                          
                    </div>                    
                  </div>
                  <div class="form-group">
                    <div class="col-md-5">                    
                      <div>
                        <label for="inputClientHubID">Client Hub ID</label>
                        <input type="text" readonly class="form-control" id="inputClientHubID" placeholder="" v-model="formData.clientHubId">                       
                      </div>                                          
                    </div>                    
                  </div>                                                      
                  <input type="hidden" class="form-control" id="inputProjectId" v-model="formData.projectId">
                </div>

                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>

              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>
    <!-- <div class="modal fade" id="modal-qrcode" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Check-In/Out QRCode</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border">
              <div class="text-center">
                <img src="https://chart.googleapis.com/chart?cht=qr&chl=Hello+World&chs=160x160&chld=L|0"
                    class="img-thumbnail img-responsive" style="max-width: 200px;margin: 10px;">
              </div>                                                                 
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onPrint($event)">Print</button>
          </div>
        </div>
      </div>
    </div>        -->

    <div id="modal-qris" class="modal-dialog-qris" style="display:none">
      <div class="popup">
        <h2 class="modal-title"><strong>QR Passcode</strong></h2>
        <div id="qrcode" class="qris">
        </div>
        <div id="message" style="color:red"></div>  
      </div>
    </div>
  </section>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import select2 from '../../components/widgets/Select2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'CheckInOutLocation',
  components: {
    datepicker, select2
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      listData: null,
      listDataTemp: null,
      listProject: null,
      listProjectForm: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        projectId: 0,
        projectName: '',
        status: '',
        usedBy: '',
        clientHubId: ''
      }
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryCheckInOutLocationByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    // inquiryCheckInOutLocationNew() {
    //   this.inquiryParam.WhereClauseByProject = ''
    //   if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
    //     this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
    //     this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
    //   }

    //   api
    //     .request('Guest', 'get', '/api/CheckInOutLocation/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
    //                              '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
    //                              '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
    //     .then(response => {
    //       var data = response.data
    //       this.listData = data.entity
    //       this.total = data.totalRows
    //       this.totalPages = data.totalPages
    //       this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    //     })
    //     .catch(error => {
    //       var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
    //       SweetAlert.fire('Error', message, 'error')
    //     })
    // },
    inquiryCheckInOutLocation() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      var arrProject = []

      api
        .request('Guest', 'get', '/api/CheckInOutLocation/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize

          this.listDataTemp.forEach(item => {
            // Populate project
            arrProject.push(item.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique
          })
        })
        .then(response => {
          // Get project
          if (arrProject.length === 0) {
            this.listData = this.listDataTemp
            return
          }
          let whereClause = 'id in (' + arrProject.join(',') + ')'
          api
            .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                          '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
            .then(response => {
              var data = response.data
              this.listProject = data.entity

              var projectName
              this.listDataTemp.forEach(item => {
                projectName = ''
                this.listProject.some(function(itemProject, index) {
                  if (item.projectId === itemProject.id) {
                    projectName = itemProject.name
                  }
                })
                item.projectName = projectName
              })
              this.listData = this.listDataTemp
            })
            .catch(error => {
              var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    inquiry() {
      this.inquiryCheckInOutLocation()
      this.getMasterData()
    },
    getProject() {
      api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProjectForm = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getMasterData() {
      this.getProject()
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.projectId = 0
      this.formData.projectName = ''
      this.formData.status = ''
      this.formData.usedBy = ''
      this.formData.clientHubId = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    showForm(row, viewMode) {
      api
        .request('Guest', 'get', '/api/CheckInOutLocation/GetDetail?Id=' + row.id, null)
        .then(response => {
          var data = response.data
          this.formData.id = data.entity.id
          this.formData.name = data.entity.name
          this.formData.projectId = data.entity.projectId
          this.formData.status = data.entity.status
          this.formData.usedBy = data.entity.usedBy
          this.formData.clientHubId = data.entity.clientHubId
        })
        .then(response => {
          this.viewType = VIEW_FORM
          this.viewMode = viewMode
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      this.showForm(row, MODE_VIEW)
    },
    onEdit(row) {
      this.showForm(row, MODE_UPDATE)
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        ProjectId: this.formData.projectId,
        Status: this.formData.status,
        UsedBy: this.formData.usedBy,
        ClientHubId: this.formData.clientHubId
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/CheckInOutLocation/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Guest', 'post', '/api/CheckInOutLocation/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    getIPAddress() {
      // https://stackoverflow.com/questions/391979/how-to-get-clients-ip-address-using-javascript
      return new Promise((resolve, reject) => {
        var w = window
        var a = new (w.RTCPeerConnection || w.mozRTCPeerConnection || w.webkitRTCPeerConnection)({
          iceServers: []
        })
        var b = () => {}
        a.createDataChannel('')
        a.createOffer(c => a.setLocalDescription(c, b, b), b)
        a.onicecandidate = c => {
          try {
            if (c.candidate) {
              resolve(c.candidate.address)
            }
          } catch (e) {
          }
        }
      })
    },
    onAssign(data) {
      SweetAlert.fire({
        title: 'Assigning Location ID?',
        text: 'Are you sure to assign this location ' + data.name + ' to this machine ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          this.getIPAddress()
            .then((response) => {
              if (response && response !== '') {
                var res = this.assignLocation(data, response)
                SweetAlert.fire('Assigning Location ID', res.message, res.status)
              }
            })
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          // SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    assignLocation(data, ipAddress) {
      var status = ''
      var message = ''

      if (!ipAddress || ipAddress === '') {
        status = 'error'
        message = 'Can\'t get IP Address of this machine'
        return { status: status, message: message }
      }

      if (data.usedBy && data.usedBy !== '' && ipAddress === data.usedBy) {
        status = 'error'
        message = 'You can\'t assign other location'
        return { status: status, message: message }
      }

      let clientHubId = window.localStorage.getItem('connectionId')
      var reqData = {
        Id: data.id,
        Name: data.name,
        ProjectId: data.projectId,
        Status: data.status,
        UsedBy: ipAddress,
        ClientHubId: clientHubId
      }
      api.request('Guest', 'post', '/api/CheckInOutLocation/Update', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
          return resData
        })
        .then(response => {
          if (response.returnStatus) {
            window.localStorage.setItem('locationId', reqData.Name)
            window.localStorage.setItem('checkInOutData', JSON.stringify(reqData))
          }
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    onDisplayQRCode(data) {
      let qrCodeString = ''
      switch (config.environment) {
        case 'Local':
          qrCodeString = config.checkInOutURLLocal
          break
        case 'Development':
          qrCodeString = config.checkInOutURLDev
          break
        case 'Production':
          qrCodeString = config.checkInOutURLPrd
          break
        default:
          break
      }

      qrCodeString = qrCodeString + '|' + data.projectId + '|' + data.projectName + '|' + data.name

      document.getElementById('qrcode').innerHTML = ''
      var qr = new window.QRCode(document.getElementById('qrcode'), {
        width: 350,
        height: 350
      })
      qr.makeCode(qrCodeString)
      window.$('#modal-qris').modal('show')
      document.getElementById('message').innerHTML = data.name

      // SweetAlert.fire({
      //   title: 'Check-in/out QRCode',
      //   html: '<img src="https://chart.googleapis.com/chart?cht=qr&chl=' + qrCodeString + '&chs=260x260&chld=L|0" class="img-responsive img-thumbnail" style="max-height:400px;max-width:400px;"> <br>' +
      //         '<h3 style="color:red; font-weight:bold;">' + data.name + '</h3>',
      //   type: 'info',
      //   showCancelButton: false,
      //   confirmButtonText: 'Print',
      //   showCloseButton: true,
      //   showLoaderOnConfirm: true
      // })
      // .then((result) => {
      //   if (result.value) {
      //   } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
      //   }
      // })
    }
  }
}
</script>

<style scoped>
.modal-dialog-qris {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height:100%;
    background-color: rgba(0,0,0,0.5);
    z-index:1900;
}
.modal-dialog-qris .popup{
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    margin: auto;
    width:600px;
    height:500px;
    text-align:center;
    font-size:20px;
    font-weight:bold;
    background-color: #F0EEEE;
    border-radius: 3px;
    box-shadow: 0px 10px 20px rgba(0,0,0,0.4);
    z-index:1950;
    font-family: 'Lato';
    font-family: Lato;
}
.modal-dialog-qris .popup .qris{
    display: inline-flex;
    padding: 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// CheckInOutLocation.vue?51d0c3d4